module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('box-widget', {
    attrs: {
      "icon": "user-circle-o"
    }
  }, [_c('template', {
    slot: "head"
  }, [_vm._v(_vm._s(_vm.$t('pos.creative.assignees-info'))), (_vm.canUpdateAssigner) ? _c('b-btn', {
    staticClass: "float-right",
    attrs: {
      "size": "sm",
      "disabled": _vm.loading,
      "loading": _vm.loading
    },
    on: {
      "click": _vm.assign
    }
  }, [(_vm.operator) ? [_vm._v(_vm._s(_vm.$t('pos.creative.cancel')))] : [_vm._v(_vm._s(_vm.$t('pos.creative.start-work')))]], 2) : _vm._e()], 1), _c('template', {
    slot: "content"
  }, [(_vm.lastAssigment) ? [(_vm.assigned) ? [_vm._v(_vm._s(_vm.$t('pos.creative.assigned-operator', {
    name: _vm.operator.name
  })))] : (_vm.unassigned) ? [_vm._v(_vm._s(_vm.$t('pos.creative.unassigned-operator', {
    user_1: _vm.lastAssigment.data.actor.name,
    user_2: _vm.unassigned.name
  })))] : _vm._e(), _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip",
      value: (_vm.getFullDate(_vm.lastAssigment.data.created_at)),
      expression: "getFullDate(lastAssigment.data.created_at)"
    }]
  }, [_vm._v(" " + _vm._s(_vm.getTimeAgo(_vm.lastAssigment.data.created_at)))])] : _vm._e()], 2)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ccc7f60"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assignees-info/AssigneesInfo.vue
// module id = 2014
// module chunks = 1